export default __webpack_public_path__ + "static/media/ai_help.4359a8f4.jpeg";